<template>
    <td>
        <GZ-MainLoader 
            v-if="loading"
            class="gz-loader_sm" 
            :loading="loading"
        />
        <div v-if="!loading" :title="`${user.lname} ${user.name} ${user.pname}`" class="gz-table__col__user__item">
            <section class="gz-table__col__user__name">
                <span v-if="user.lname">{{ user.lname }}</span>
                <span v-if="user.name">&nbsp;{{ user.name.charAt(0) }}</span>
                <span v-if="user.pname">.{{ user.pname.charAt(0) }}</span>
            </section>
            
            <section v-if="user.phone">
                <div class="gz-table__col__user__phone">
                    <span><nobr>&#9742;&nbsp;{{ user.phone }}</nobr></span>
                </div>
            </section>
        </div>
    </td>
</template>

<script>
export default {
    name: 'Owner',

    props: {
        id: String
    },
    data() {
        return {
            user: {},
            loading: false
        }
    },
    mounted() {
        this.getUser(this.id)
    },
    methods: {
        async getUser(id) {
            this.loading = true
            const userData = await this.$store.dispatch('usersGetUser', id)
            this.user = userData.attributes
            this.loading = false
            console.log(userData)
        }
    }
}
</script>